import { ButtonColor, ButtonFontSize, ButtonHeight, ButtonType } from '../../gzButton/types';
import { LitElement } from 'lit';

export enum TemplateType {
  NONE = 0,
  STRING = 1,
  ELEMENT = 2,
}

export interface SectionConfiguration {
  sectionTitle: string;
  sectionContents: Array<SectionContent>;
  actions?: Array<SectionAction>;
}

export interface SectionTitleConfig {
  fontSize: string;
  fontWeight: string;
}

export interface SectionContent {
  label: string;
  content: number | string | LitElement | HTMLElement;
  templateType?: TemplateType;
  canCopy?: boolean;
  clampLine?: boolean;
  copyConfirmationMessage?: string;
}

export enum SectionActionType {
  GZ_BUTTON = 1,
}

export interface ActionConfigTypeButton {
  type?: ButtonType;
  color?: ButtonColor;
  buttonHeight?: ButtonHeight;
  buttonFontSize?: ButtonFontSize;
  disabled?: boolean;
  id?: string;
  tooltip?: string;
}

export interface SectionAction {
  label: string;
  type: SectionActionType;
  eventName: string;
  eventData: any;
  itemConfig: ActionConfigTypeButton; //Add more interfaces here when needed
}
